// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal.staff-invitation-modal__container{
    background-color: var(--new-background-color);
}
.staff-invitation-modal__container .modal__container{
    padding: unset;
    max-width: unset;
    width: 70%;
}

.staff-invitation-modal__content{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 48px;
}

.staff-invitation-modal__team-image{
    margin-bottom: 16px;
}

.staff-invitation-modal__team-image .icon-ball{
    font-size: 36px;
    padding: 6px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    color: var(--white-color);
}

.staff-invitation-modal__team-image img{
    width: 48px;
    height: 48px;
    border-radius: 50%;
}

.staff-invitation-modal__team-name{
    margin-top: 16px;
}

.staff-invitation-modal__tournament-info{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 34px;
    gap: 16px;
}

.staff-invitation-modal__tournament-info .icon-ball{
    font-size: 22px;
    padding: 4px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    color: var(--white-color);
}

.staff-invitation-modal__tournament-info img{
    width: 30px;
    height: 30px;
    border-radius: 50%;
}

.staff-invitation-modal__container-create.baloa-name{
    justify-content: center;
    color: var(--primary-very-dark-color);
    font-size: 17px;
    text-align: center;
    margin-left: 15px;
    margin-right: 15px;
    
}
/* 
.staff-invitation-modal__container-create_button{
    width: 272px;
    height: 36px;
    justify-content: center;
    align-content: center;
    font-size: 17px;
}

.staff-invitation-modal__container-create_button span{
    font-size: 17px;
    width: 68px;
    height: 20px;
    line-height: 20px;
    align-items: center;
    letter-spacing: 0.0025em;
} */

.staff-invitation-modal__buttons{
    display: flex;
    flex-direction: column;
    align-items: center;
}

.staff-invitation-modal__buttons-button{
    margin-top: 34px        ;
    margin-bottom: 24px;
}

.staff-invitation-modal__buttons .baloa-table-column{
    cursor: pointer;
}

.staff-invitation-modal__container .modal2__container {
    width: 80%;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .staff-invitation-modal__container .modal__container{
        width: 100%;
    }

    .staff-invitation-modal__content strong{
        display: contents;
    }

    .staff-invitation-modal__content {
        padding: var(--space-x2) var(--space);
    }

}`, "",{"version":3,"sources":["webpack://./src/app/tournaments/components/staff-invitation-modal/StaffInvitationModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,6CAA6C;AACjD;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,qCAAqC;IACrC,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;;AAEtB;AACA;;;;;;;;;;;;;;;;GAgBG;;AAEH;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,qCAAqC;IACzC;;AAEJ","sourcesContent":[".modal.staff-invitation-modal__container{\n    background-color: var(--new-background-color);\n}\n.staff-invitation-modal__container .modal__container{\n    padding: unset;\n    max-width: unset;\n    width: 70%;\n}\n\n.staff-invitation-modal__content{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    padding: 48px;\n}\n\n.staff-invitation-modal__team-image{\n    margin-bottom: 16px;\n}\n\n.staff-invitation-modal__team-image .icon-ball{\n    font-size: 36px;\n    padding: 6px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    color: var(--white-color);\n}\n\n.staff-invitation-modal__team-image img{\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n}\n\n.staff-invitation-modal__team-name{\n    margin-top: 16px;\n}\n\n.staff-invitation-modal__tournament-info{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 34px;\n    gap: 16px;\n}\n\n.staff-invitation-modal__tournament-info .icon-ball{\n    font-size: 22px;\n    padding: 4px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    color: var(--white-color);\n}\n\n.staff-invitation-modal__tournament-info img{\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n}\n\n.staff-invitation-modal__container-create.baloa-name{\n    justify-content: center;\n    color: var(--primary-very-dark-color);\n    font-size: 17px;\n    text-align: center;\n    margin-left: 15px;\n    margin-right: 15px;\n    \n}\n/* \n.staff-invitation-modal__container-create_button{\n    width: 272px;\n    height: 36px;\n    justify-content: center;\n    align-content: center;\n    font-size: 17px;\n}\n\n.staff-invitation-modal__container-create_button span{\n    font-size: 17px;\n    width: 68px;\n    height: 20px;\n    line-height: 20px;\n    align-items: center;\n    letter-spacing: 0.0025em;\n} */\n\n.staff-invitation-modal__buttons{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.staff-invitation-modal__buttons-button{\n    margin-top: 34px        ;\n    margin-bottom: 24px;\n}\n\n.staff-invitation-modal__buttons .baloa-table-column{\n    cursor: pointer;\n}\n\n.staff-invitation-modal__container .modal2__container {\n    width: 80%;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .staff-invitation-modal__container .modal__container{\n        width: 100%;\n    }\n\n    .staff-invitation-modal__content strong{\n        display: contents;\n    }\n\n    .staff-invitation-modal__content {\n        padding: var(--space-x2) var(--space);\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
